import { useNavigate } from "react-router-dom";

export const useNavigateAndScroll = () => {
  const navigate = useNavigate();

  const navigateAndScroll = (path, hash) => {
    if (hash) {
      // Let React Router handle the hash navigation
      navigate({
        pathname: path,
        hash: `#${hash}`,
      });

      // Wait for the navigation to complete and DOM to update
      setTimeout(() => {
        const element = document.getElementById(hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 0);
    } else {
      // Simple navigation without hash
      navigate(path);
    }

    // navigate(path, { replace: true });

    // // Wait for the navigation to complete
    // setTimeout(() => {
    //   if (hash) {
    //     const element = document.getElementById(hash);
    //     if (element) {
    //       element.scrollIntoView({ behavior: "smooth" });
    //     }
    //   }
    // }, 0);
  };

  return navigateAndScroll;
};
